export default __webpack_public_path__ + "static/media/woman-with-phone.540a5845.png";